/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    arrayOf, string,
    func, shape,
} from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import InputLabel from '@material-ui/core/InputLabel';
import { makeStyles } from '@material-ui/core/styles';
import { Input } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    elementHidden: {
        display: 'none',
    },
    select: {
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: '26px',
        letterSpacing: '0.18px',
        '& .MuiNativeSelect-select': {
            background: '#FAFAFA',
            padding: '8px 12px 8px 12px !important',
            marginTop: '13px',
            minHeight: '22px',
            textTransform: 'capitalize',
            [theme.breakpoints.down(600)]: {
                padding: '8px 13px',
                margin: '13px 0px 0px',
                fontSize: '18px',
            },
            '@media screen and (max-width: 375px)': {
                fontSize: '0.938rem',
            },
        },
        '& .MuiNativeSelect-filled': {
            background: '#FAFAFA',
        },
        '& svg': {
            fill: '#2f2f2f',
            marginTop: '5px',
        },
    },
    fieldBlock: {
        '& label': {
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: '18px',
            letterSpacing: '0.12px',
            paddingTop: '4px',
        },
        '& [class*="shrink"]': {
            top: '12px',
            color: theme.palette.giftFinderSelectColor,
        },
        '& .MuiInput-select:focused': {
            background: theme.palette.myAccount?.container?.backgroundColor,
        },
        '& label + .MuiInput-formControl': {
            width: '339px',
            height: '58px',
            padding: '0px 12px 0px 0px',
            alignItems: 'center',
            borderRadius: '3px',
            border: '1px solid #C4C4C4',
            background: '#FAFAFA',
            marginTop: 0,
            '@media screen and (max-width: 600px)': {
                width: '100%',
            },
        },
    },

}));

const OccasionDropdown = (props) => {
    const { holidays, selected, onChange } = props;
    const defaultSelectValue = holidays[0].id;
    const classes = useStyles();

    return (
        <FormControl role="region" className={`${classes.fieldBlock}`} aria-label="Selectyourgift" variant="outlined">
            <InputLabel className={classes.yourList} htmlFor="your_gift_list">Your Gift List</InputLabel>
            <NativeSelect
                defaultValue=""
                className={`${classes.select} ${classes.nativeSelect}`}
                value={selected || defaultSelectValue}
                disableUnderline
                onChange={onChange}
                input={(
                    <Input
                        name="Your Gift List"
                        id="your_gift_list"
                        tabIndex="-1"
                    />
                )}
            >
                {
                    holidays?.map((d) => <option  key={d.id} aria-hidden="true" value={d.id}>{d.name.toLowerCase()}</option>)
                }
            </NativeSelect>
        </FormControl>
    );
};

OccasionDropdown.propTypes = {
    holidays: arrayOf(
        shape({
            id: string,
            name: string,
        }),
    ).isRequired,
    onChange: func.isRequired,
    selected: string.isRequired,
};

export default OccasionDropdown;
